import React, {
  ChangeEvent,
  ForwardedRef,
  forwardRef,
} from 'react';
import forEach from 'lodash/forEach';
import {
  FileLocalUrl,
} from 'pages/Dashboard/components/FilePicker';

export type Props = {
  allowedFileTypes?: string;
  onFileUpload: (data: FileLocalUrl[], file?: File) => void;
  multiple?: boolean;
};

const FileInput = forwardRef(({
  onFileUpload,
  allowedFileTypes,
  multiple = false,
}: Props, ref: ForwardedRef<HTMLInputElement>) => {
  const handleFileSelection = async (event: ChangeEvent<HTMLInputElement>) => {
    const { files = [] } = event.target;
    const totalFiles = files?.length ?? 0;

    if (totalFiles > 0) {
      const fileWithUrl: FileLocalUrl[] = [];
      forEach(files, async (file: File) => {
        const reader = new FileReader();
        reader.onload = async (e: ProgressEvent<FileReader>) => {
          fileWithUrl.push({ dataUrl: e.target?.result as string, file });
          if (fileWithUrl.length === totalFiles) {
            await onFileUpload(fileWithUrl, file);
            event.target.value = '';
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  return (
    <input
      ref={ref}
      type="file"
      accept={allowedFileTypes}
      onChange={handleFileSelection}
      multiple={multiple}
      hidden
    />
  );
});

export default FileInput;
